import React, { ReactNode, useState, useEffect } from "react";
import "./App.css";
import moment from "moment-timezone";
import axios from "axios";
import { useNavigate, useLocation, Navigate } from "react-router-dom";
import Login from "./components/Login";
import Explore from "./Explore";
import ForgotPassword from "./components/ForgotPassword";
import Settings from "./components/Settings";
import Layout from "./components/Layout";
import HomePage from "./components/Home/HomePage";
import MeDashboard from "components/MeDasboard/MeDashboard";
import ManageUserCards from "components/Manage User/ManageUserCards";
import TeamsDashboard from "components/Teams/TeamsDashboard";
import UsersList from "components/Manage User/UsersList";
import UserStatus from "components/Manage User/UserStatus";
import UserProfile from "components/Manage User/UserProfile";
import ManageTeams from "components/Teams/ManageTeams/ManageTeams";
import LeaderBoard from "components/Teams/Leaderboard/LeaderBoard";
// import IndividualUserProfile from "components/Teams/Leaderboard/IndividualUserProfile";
import TeamsMemberList from "components/Teams/ManageTeams/TeamsMemberList";
import Achievement from "components/MeDasboard/MeAchievements/Achievement";
import HierarchyComponent from "components/Hierarchy component/HierarchyComponent";
import HrPullCards from "components/HR Pull/HrPullCards";
import MeActivity from "components/Activity/MeActivity";
import EditGoal from "components/Goal Settings/EditGoal";
import HrViewHistory from "components/HR Pull/HrViewHistory";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import ChallangesPage from "components/Challenges/ChallangesPage";
import { Activity } from "lucide-react";
import Rewards from "components/Rewards/Rewards";
import RedeemHistory from "components/Rewards/RedeemHistory";
import AdminRewards from "components/Rewards/AdminRewards";
import GoalSettings from "components/Goal Settings/GoalSettings";
import AddGoal from "components/Goal Settings/AddGoal";
import CreateChallenges from "components/Challenges/CreateChallenges";
import EditUser from "components/Manage User/EditUser";
import UserProfilePage from "components/User-profiles/UserProfilePage";
import HealthForm from "./components/HealthForm/HealthForm";
import Alerts from "./components/Alerts/Alerts";
import { setupSessionInterceptor } from "./components/utils/sessionHandler";
import ActivityLog from "components/ActivityLog";
//import { setupSessionInterceptor } from "./components/utils/sessionHandler";
import SessionModal from "components/utils/SessionModal";
import { useSaveSessionOnClose } from "components/utils/SessionCheckUtils";
import ForcedResetPassword from "components/Manage User/ForcedResetPassword";
import TeamsComparison from "components/Teams/ManageTeams/Teams-Comparision/TeamsComparison";
import AdminLatestNews from "components/AdminLatestNews";
import ChallengeDetailPage from "components/Challenges/ChallengeDetailPage";
import LayoutWithFeedback from "components/Floaters/LayoutWithFeedback";
import AdminFeedbackPage from "components/Admin_Feedback_Page/AdminFeedbackPage";
import GetStartedPage from "components/Get_Started/GetStartedPage";
import ProtectedRoute from "./components/utils/ProtectedRoute";
import AppConfigurationPage from "components/App_Configurations/AppConfigurationPage";
import PublicLeaderboard from "components/Teams/Leaderboard/PublicLeaderboard";
import LeaderHeirarchy from "components/Teams/ManageTeams/Leader_Heirarchy/LeaderHeirarchy";
//import ResetPassword from "./components/ResetPassword";
import ResetPassword from "./components/ResetPassword";
import RecoveryCodeAccess from "./components/User-profiles/RecoveryCodeAccess";
import RecoveryCodeDisplay from "./components/User-profiles/RecoveryCodeDisplay";
import TwoFa from "./components/User-profiles/TwoFa";
import { ChakraProvider } from "@chakra-ui/react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; // Import toast styles
import DownloadAppPage from "components/Get_Started/DownloadAppPage";
import { ReactFlowProvider } from "reactflow";
import PrivacyPolicyPage from "components/Get_Started/PrivacyPolicyPage";
import ViewReportees from "components/Teams/ManageTeams/Leaders/ViewReportees";
import ReporteesLeaderboard from "components/Teams/ManageTeams/Leaders/ReporteesLeaderboard";
import { ConsentProvider, useConsent } from "components/utils/ConsentContext";
import TeamsStats from "components/Teams/TeamStats/TeamStats";
import BadgeConfigurations from "components/Badge_Configuration/BadgeConfigurations";
import ViewChats from "components/Challenges/ViewChats";
import ChallengeDashboard from "components/Challenges/ChallengeDashboard";
import ChallengesTeamPerformance from "components/Challenges/ChallengesTeamPerformance";
import Insights from "components/MeDasboard/Insights";
import RulesConfigurations from "components/Rules_Configurations/RulesConfigurations";
// import ChallengeDashboard from "components/Challenges/ChallengeDashboard";
// import ViewChats from "components/Challenges/ViewChats";
import OrgManageTeams from "components/Config/OrgManageTeams";
import GeneralConfiguration from "components/Config/GeneralConfigurations";
import LevelConfigurations from "components/Config/LevelConfigurations";
import StreakConfigurations from "components/Config/StreakConfigurations";
import PluginConfiguration from "components/Config/PluginConfiguration";
import OrgConfiguration from "components/Config/OrgManageTeams";
import OrgServerConfiguration from "components/Config/OrgServerconfiguration";
import ServerConfig from "components/Config/ServerConfig";
import AddSystemConfig from "components/Config/AddSystemConfig";
import SystemConfigManageTeam from "components/Config/SystemConfigManageTeam";
import SystemLevelConfig from "components/Config/SystemLevelConfig";
import ChangePassword from "components/User-profiles/ChangePassword";
import Streaktrends from "components/MeDasboard/Streaktrends";
import AllRewardsPage from "components/Rewards/AllRewardsPage";
import StreakLeaderBord from "components/Teams/Leaderboard/StreakLeaderboard";
import OrgDashboard from "components/OrgDashboard/OrgDashboard";
import { ThemeProvider } from "./ThemeContext";
import SessionTimeoutManager from "components/SessionTimeoutManager";

const beAddress =
  window._env_?.REACT_APP_API_URL || process.env.REACT_APP_API_URL;

interface SessionCheckProps {
  children: ReactNode;
}

function SessionCheck({ children }: SessionCheckProps) {
  const navigate = useNavigate();
  const [isSessionValid, setIsSessionValid] = useState(true);
  const [isSessionModalOpen, setIsSessionModalOpen] = useState(false);
  const [sessionExpiry, setSessionExpiry] = useState(
    localStorage.getItem("expiry_datetime") || null
  );

  useSaveSessionOnClose(
    localStorage.getItem("user_uid") || "",
    localStorage.getItem("session_uid") || ""
  );

  useEffect(() => {
    const checkSession = () => {
      const expiryTime = localStorage.getItem("expiry_datetime");
      if (!expiryTime) {
        setIsSessionModalOpen(false);
        return;
      }
      const currentTime = moment.utc();
      const expiryStr = moment(expiryTime);
      const timeDiff = expiryStr.diff(currentTime, "seconds");

      if (timeDiff <= 60 && timeDiff > 0) {
        setIsSessionModalOpen(true);
      }

      if (timeDiff <= 0) {
        handleSessionModalClose();
      }
    };

    const interval = setInterval(checkSession, 60000);
    return () => clearInterval(interval);
  }, []);

  const extendSession = async () => {
    const sessionUid = localStorage.getItem("session_uid");
    const userUid = localStorage.getItem("user_uid");
    try {
      const response = await axios.post(
        `${beAddress}/api/extend-session`,
        {},
        {
          headers: {
            "session-uid": sessionUid,
            "user-uid": userUid,
          },
        }
      );

      if (response.status === 200 && response.data.status === "Success") {
        const newExpiry = response.data?.expiry_datetime;
        localStorage.setItem("expiry_datetime", newExpiry);
        setSessionExpiry(newExpiry);
        setIsSessionModalOpen(false);
      }
    } catch (error) {
      console.error("Failed to extend session:", error);
    }
  };

  const handleSessionModalClose = () => {
    setIsSessionModalOpen(false);
    navigate("/login");
    localStorage.clear();
  };

  if (!isSessionValid && !isSessionModalOpen) {
    return null;
  }

  return (
    <>
      {children}
      <SessionModal
        visible={isSessionModalOpen}
        onOk={handleSessionModalClose}
        onCancel={handleSessionModalClose}
        onExtend={extendSession}
      />
    </>
  );
}

const fetchUserProfile = async () => {
  let userUid = localStorage.getItem("user_uid");
  let sessionUid = localStorage.getItem("session_uid");
  try {
    const response = await axios.get(`${beAddress}/api/user-profile`, {
      headers: {
        "session-uid": sessionUid,
        "user-uid": userUid,
      },
    });

    if (response.status === 200 && response.data.status === "Success") {
      const userInfo = response.data.data;
      localStorage.setItem("org_uid", userInfo.org_uid);
      localStorage.setItem("expiry_datetime", userInfo.expiry_datetime);
      localStorage.setItem("timeout_interval", userInfo.timeout_interval);
      localStorage.setItem("privilege", userInfo.priviledge);
      // localStorage.setItem(
      //   "job_programming_unit",
      //   userInfo.job_programming_unit
      // );
      // localStorage.setItem("device_control", userInfo.device_control);
      // localStorage.setItem("device_control_role", userInfo.device_control_role);
      // localStorage.setItem("user_role", userInfo.user_role);
      // localStorage.setItem("user_manage_access", userInfo.user_manage_access);
      // localStorage.setItem("user_control_role", userInfo.user_control_role);
      // localStorage.setItem("theme", userInfo.web_theme);
      localStorage.setItem("timeZone", userInfo.timezone);
      localStorage.setItem("session_timeout", userInfo.session_timeout);
      localStorage.setItem("refresh_time", userInfo.refresh_time);
      // localStorage.setItem("metric_filter_type", userInfo.metric_filter_type);
      // localStorage.setItem("metric_filter_value", userInfo.metric_filter_value);
      return true;
    } else {
      return false;
    }
  } catch (error) {
    console.error("Error fetching user profile:", error);
    return false;
  }
};
const App: React.FC = () => {
  return (
    <Router>
      <AppContent />
    </Router>
  );
};

const AppContent: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleSessionUserPersist = async () => {
      if (
        localStorage.getItem("user_uid") &&
        localStorage.getItem("session_uid")
      ) {
        let userProfileSuccess = await fetchUserProfile();
        if (userProfileSuccess) {
          navigate("/home");
        } else {
          localStorage.clear();
        }
      }
    };

    if (location.pathname === "/" || location.pathname === "/login") {
      handleSessionUserPersist();
    }
  }, [navigate, location.pathname]);
  // useEffect(() => {
  //   setupSessionInterceptor();
  // }, []);

// this is to prevent back button after logout
useEffect(() => {
  const handlePageShow = (event: PageTransitionEvent) => {
    if (event.persisted) {
      window.location.reload();
    }
  };

  window.addEventListener("pageshow", handlePageShow);
  return () => window.removeEventListener("pageshow", handlePageShow);
}, []);

  const ResetPasswordWrapper = () => {
    useEffect(() => {
      // Clear the flag on initial load to prevent re-entry
      return () => {
        localStorage.removeItem("password_expired");
      };
    }, []);

    return <ResetPassword />;
  };
  return (
    <ThemeProvider>
      <>
        <SessionTimeoutManager />
        <Routes>
          <Route path="/" element={<Login />} />

          <Route path="/login" element={<Login />} />
          <Route path="/privacypolicy-page" element={<PrivacyPolicyPage />} />

          {/* <Route
          path="/get-started"
          element={
                <GetStartedPage />
          }
        /> */}
          <Route
            path="/app-download"
            element={
              <ConsentProvider>
                <DownloadAppPage />
              </ConsentProvider>
            }
          />

          <Route path="/explore" element={<Explore />} />
          <Route
            path="/home"
            element={

              <ProtectedRoute>
                <LayoutWithFeedback>
                  <HomePage />
                </LayoutWithFeedback>
              </ProtectedRoute>

            }
          />

          <Route
            path="/user-profile"
            element={

              <ProtectedRoute>
                <LayoutWithFeedback>
                  <UserProfilePage />
                </LayoutWithFeedback>
              </ProtectedRoute>

            }
          />

          <Route
            path="/me-dashboard"
            element={

              <ProtectedRoute>
                <LayoutWithFeedback>
                  <MeDashboard />
                </LayoutWithFeedback>
              </ProtectedRoute>

            }
          />
          <Route
            path="/streak-trends"
            element={

              <ProtectedRoute>
                <LayoutWithFeedback>
                  <Streaktrends />
                </LayoutWithFeedback>
              </ProtectedRoute>

            }
          />
          <Route
            path="/streak-Leaderboard"
            element={

              <ProtectedRoute>
                <LayoutWithFeedback>
                  <StreakLeaderBord />
                </LayoutWithFeedback>
              </ProtectedRoute>

            }
          />
          <Route
            path="/achievements"
            element={

              <ProtectedRoute>
                <LayoutWithFeedback>
                  <Achievement />
                </LayoutWithFeedback>
              </ProtectedRoute>

            }
          />
          <Route
            path="/activity"
            element={

              <ProtectedRoute>
                <LayoutWithFeedback>
                  <MeActivity />
                </LayoutWithFeedback>
              </ProtectedRoute>

            }
          />
          <Route
            path="/team-stats"
            element={

              <ProtectedRoute
                allowedRoles={["creator", "user", "all", "viewer"]}
              >
                <LayoutWithFeedback>
                  <TeamsStats />
                </LayoutWithFeedback>
              </ProtectedRoute>

            }
          />
          <Route
            path="/teams-dashboard"
            element={

              <ProtectedRoute>
                <LayoutWithFeedback>
                  <TeamsDashboard />
                </LayoutWithFeedback>
              </ProtectedRoute>

            }
          />

          <Route
            path="/view-teams"
            element={

              <ProtectedRoute>
                <LayoutWithFeedback>
                  <ManageTeams />
                </LayoutWithFeedback>
              </ProtectedRoute>

            }
          />
          <Route
            path="/leader-hierarchy"
            element={

              <ProtectedRoute>
                <LayoutWithFeedback>
                  <LeaderHeirarchy />
                </LayoutWithFeedback>
              </ProtectedRoute>

            }
          />
          <Route
            path="/view-reportees"
            element={

              <ProtectedRoute>
                <LayoutWithFeedback>
                  <ViewReportees />
                </LayoutWithFeedback>
              </ProtectedRoute>

            }
          />
          <Route
            path="/reportees-leaderboard"
            element={

              <ProtectedRoute>
                <LayoutWithFeedback>
                  <ReporteesLeaderboard />
                </LayoutWithFeedback>
              </ProtectedRoute>

            }
          />

          <Route
            path="/teams-member-list"
            element={

              <ProtectedRoute>
                <LayoutWithFeedback>
                  <TeamsMemberList />
                </LayoutWithFeedback>
              </ProtectedRoute>

            }
          />
          <Route
            path="/Public-leaderboard"
            element={

              <ProtectedRoute>
                <LayoutWithFeedback>
                  <PublicLeaderboard />
                </LayoutWithFeedback>
              </ProtectedRoute>

            }
          />
          <Route
            path="/my-org"
            element={

              <ProtectedRoute>
                <LayoutWithFeedback>
                  <HierarchyComponent />
                </LayoutWithFeedback>
              </ProtectedRoute>

            }
          />
          <Route
            path="/hr-view-history"
            element={

              <ProtectedRoute
                allowedPrivileges={["orgadmin", "systemadmin"]}
                allowedRoles={["creator", "all"]}
              >
                <LayoutWithFeedback>
                  <HrViewHistory />
                </LayoutWithFeedback>
              </ProtectedRoute>

            }
          />

          <Route
            path="/rewards"
            element={

              <ProtectedRoute>
                <LayoutWithFeedback>
                  <Rewards />
                </LayoutWithFeedback>
              </ProtectedRoute>

            }
          />
          <Route
            path="/admin-rewards"
            element={

              <ProtectedRoute>
                <LayoutWithFeedback>
                  <AdminRewards />
                </LayoutWithFeedback>
              </ProtectedRoute>

            }
          />
          <Route
            path="/all-rewards"
            element={

              <ProtectedRoute>
                <LayoutWithFeedback>
                  <AllRewardsPage />
                </LayoutWithFeedback>
              </ProtectedRoute>

            }
          />

          <Route
            path="/rewards-history"
            element={

              <ProtectedRoute>
                <LayoutWithFeedback>
                  <RedeemHistory />
                </LayoutWithFeedback>
              </ProtectedRoute>

            }
          />

          <Route
            path="/goal-settings"
            element={

              <ProtectedRoute>
                <LayoutWithFeedback>
                  <GoalSettings />
                </LayoutWithFeedback>
              </ProtectedRoute>

            }
          />

          <Route
            path="/add-goal"
            element={

              <ProtectedRoute>
                <LayoutWithFeedback>
                  <AddGoal />
                </LayoutWithFeedback>
              </ProtectedRoute>

            }
          />

          <Route
            path="/edit-goal/:goal_uid"
            element={

              <ProtectedRoute>
                <LayoutWithFeedback>
                  <EditGoal />
                </LayoutWithFeedback>
              </ProtectedRoute>

            }
          />

          <Route
            path="/manage-user"
            element={

              <ProtectedRoute
                allowedPrivileges={["orgadmin", "systemadmin"]}
                allowedRoles={["creator", "all"]}
              >
                <LayoutWithFeedback>
                  <ManageUserCards />
                </LayoutWithFeedback>
              </ProtectedRoute>

            }
          />
          <Route
            path="/user-list"
            element={

              <ProtectedRoute>
                <LayoutWithFeedback>
                  <UsersList />
                </LayoutWithFeedback>
              </ProtectedRoute>

            }
          />
          <Route
            path="/user-status"
            element={

              <ProtectedRoute>
                <LayoutWithFeedback>
                  <UserStatus />
                </LayoutWithFeedback>
              </ProtectedRoute>

            }
          />
          <Route
            path="/user-profile/:userId"
            element={

              <ProtectedRoute>
                <LayoutWithFeedback>
                  <UserProfile />
                </LayoutWithFeedback>
              </ProtectedRoute>

            }
          />
          <Route
            path="/recovery-code-access"
            element={

              <ProtectedRoute>
                <LayoutWithFeedback>
                  <RecoveryCodeAccess />
                </LayoutWithFeedback>
              </ProtectedRoute>

            }
          />
          <Route
            path="recovery-code-display"
            element={

              <ProtectedRoute>
                <LayoutWithFeedback>
                  <RecoveryCodeDisplay />
                </LayoutWithFeedback>
              </ProtectedRoute>

            }
          />
          <Route
            path="two-factor-auth"
            element={

              <ProtectedRoute>
                <LayoutWithFeedback>
                  <TwoFa />
                </LayoutWithFeedback>
              </ProtectedRoute>

            }
          />
          <Route
            path="/manage-user-edit"
            element={

              <ProtectedRoute
                allowedPrivileges={["orgadmin", "systemadmin"]}
                allowedRoles={["creator", "all"]}
              >
                <LayoutWithFeedback>
                  <EditUser />
                </LayoutWithFeedback>
              </ProtectedRoute>

            }
          />

          <Route
            path="/challenges"
            element={

              <ProtectedRoute>
                <LayoutWithFeedback>
                  <ChallangesPage />
                </LayoutWithFeedback>
              </ProtectedRoute>

            }
          />
          <Route
            path="/Challenges-detail"
            element={

              <ProtectedRoute>
                <LayoutWithFeedback>
                  <ChallengeDetailPage />
                </LayoutWithFeedback>
              </ProtectedRoute>

            }
          />
          {/* <Route
          path="/view-chats"
          element={
             
              <ProtectedRoute>
                <LayoutWithFeedback>
                  <ViewChats />
                </LayoutWithFeedback>
              </ProtectedRoute>
             
          }
        /> */}
          <Route
            path="/insights"
            element={

              <ProtectedRoute>
                <LayoutWithFeedback>
                  <Insights />
                </LayoutWithFeedback>
              </ProtectedRoute>

            }
          />
          <Route
            path="/rules-Configurations"
            element={

              <ProtectedRoute
                allowedPrivileges={["orgadmin", "systemadmin"]}
                allowedRoles={["creator", "all"]}
              >
                <LayoutWithFeedback>
                  <RulesConfigurations />
                </LayoutWithFeedback>
              </ProtectedRoute>

            }
          />
          <Route
            path="/Challenges-dashboard"
            element={

              <ProtectedRoute>
                <LayoutWithFeedback>
                  <ChallengeDashboard />
                </LayoutWithFeedback>
              </ProtectedRoute>

            }
          />
          <Route
            path="/Challenges-team_performance"
            element={

              <ProtectedRoute>
                <LayoutWithFeedback>
                  <ChallengesTeamPerformance />
                </LayoutWithFeedback>
              </ProtectedRoute>

            }
          />
          <Route
            path="/achievements"
            element={

              <ProtectedRoute>
                <LayoutWithFeedback>
                  <Achievement />
                </LayoutWithFeedback>
              </ProtectedRoute>

            }
          />
          <Route
            path="/hr-pull"
            element={

              <ProtectedRoute
                allowedPrivileges={["orgadmin", "systemadmin"]}
                allowedRoles={["creator", "all"]}
              >
                <LayoutWithFeedback>
                  <HrPullCards />
                </LayoutWithFeedback>
              </ProtectedRoute>

            }
          />
          <Route
            path="/leaderboard"
            element={

              <ProtectedRoute>
                <LayoutWithFeedback>
                  <LeaderBoard />
                </LayoutWithFeedback>
              </ProtectedRoute>

            }
          />
          {/* <Route
          path="/individualuserprofile/:user_uid"
          element={
             
              <Layout>
                <IndividualUserProfile />
              </Layout>
             
          }
        /> */}
          <Route
            path="/create-challenges"
            element={

              <ProtectedRoute
                allowedPrivileges={["orgadmin", "systemadmin"]}
                allowedRoles={["creator", "all"]}
              >
                <LayoutWithFeedback>
                  <CreateChallenges />
                </LayoutWithFeedback>
              </ProtectedRoute>

            }
          />
          <Route
            path="/health-form"
            element={

              <ProtectedRoute>
                <LayoutWithFeedback>
                  <HealthForm />
                </LayoutWithFeedback>
              </ProtectedRoute>

            }
          />
          <Route
            path="/alerts"
            element={

              <ProtectedRoute>
                <LayoutWithFeedback>
                  <Alerts />
                </LayoutWithFeedback>
              </ProtectedRoute>

            }
          />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route
            path="/settings"
            element={

              <ProtectedRoute>
                <LayoutWithFeedback>
                  <Settings />
                </LayoutWithFeedback>
              </ProtectedRoute>

            }
          />
          <Route
            path="/activity-logs"
            element={

              <ProtectedRoute>
                <LayoutWithFeedback>
                  <ActivityLog />
                </LayoutWithFeedback>
              </ProtectedRoute>

            }
          />
          <Route
            path="/Latest-news"
            element={
              <ProtectedRoute
                allowedRoles={["creator", "all"]}
                allowedPrivileges={["orgadmin", "systemadmin"]}
                children={
                  <LayoutWithFeedback>
                    <AdminLatestNews />
                  </LayoutWithFeedback>
                }
              />
            }
          />

          <Route
            path="/Feedback-list"
            element={

              <ProtectedRoute
                allowedPrivileges={["orgadmin", "systemadmin", "user"]}
                allowedRoles={["creator", "all", "viewer", "user"]}
              >
                <LayoutWithFeedback>
                  <AdminFeedbackPage />
                </LayoutWithFeedback>
              </ProtectedRoute>

            }
          />

          <Route
            path="/App-Configurations"
            element={

              <ProtectedRoute
                allowedPrivileges={["orgadmin", "systemadmin"]}
                allowedRoles={["creator", "all"]}
              >
                <LayoutWithFeedback>
                  <AppConfigurationPage />
                </LayoutWithFeedback>
              </ProtectedRoute>

            }
          />
          <Route
            path="/badge-Configurations"
            element={

              <ProtectedRoute
                allowedPrivileges={["orgadmin", "systemadmin"]}
                allowedRoles={["creator", "all"]}
              >
                <LayoutWithFeedback>
                  <BadgeConfigurations />
                </LayoutWithFeedback>
              </ProtectedRoute>

            }
          />

          <Route
            path="/org-server-configuration"
            element={

              <ProtectedRoute>
                <LayoutWithFeedback>
                  <OrgServerConfiguration />
                </LayoutWithFeedback>
              </ProtectedRoute>

            }
          />
          <Route
            path="/org-manage-teams"
            element={

              <ProtectedRoute>
                <LayoutWithFeedback>
                  <OrgManageTeams />
                </LayoutWithFeedback>
              </ProtectedRoute>

            }
          />
          <Route
            path="/org-dashboard"
            element={

              <ProtectedRoute
                allowedPrivileges={["orgadmin", "systemadmin"]}
              >
                <LayoutWithFeedback>
                  <OrgDashboard />
                </LayoutWithFeedback>
              </ProtectedRoute>

            }
          />
          <Route
            path="/server-config"
            element={

              <ProtectedRoute>
                <LayoutWithFeedback>
                  <ServerConfig />
                </LayoutWithFeedback>
              </ProtectedRoute>

            }
          />

          <Route
            path="/system-org-manage-team"
            element={

              <ProtectedRoute>
                <LayoutWithFeedback>
                  <SystemConfigManageTeam />
                </LayoutWithFeedback>
              </ProtectedRoute>

            }
          />

          <Route
            path="/system-level-config"
            element={

              <ProtectedRoute>
                <LayoutWithFeedback>
                  <SystemLevelConfig />
                </LayoutWithFeedback>
              </ProtectedRoute>

            }
          />

          <Route
            path="/add-system-config"
            element={

              <ProtectedRoute
                allowedPrivileges={["orgadmin", "systemadmin"]}
                allowedRoles={["creator", "all"]}
              >
                <LayoutWithFeedback>
                  <AddSystemConfig />
                </LayoutWithFeedback>
              </ProtectedRoute>

            }
          />

          <Route
            path="/general-configurations"
            element={

              <ProtectedRoute>
                <LayoutWithFeedback>
                  <GeneralConfiguration />
                </LayoutWithFeedback>
              </ProtectedRoute>

            }
          />
          <Route
            path="/level-configurations"
            element={

              <ProtectedRoute>
                <LayoutWithFeedback>
                  <LevelConfigurations />
                </LayoutWithFeedback>
              </ProtectedRoute>

            }
          />
          <Route
            path="/streak-configurations"
            element={

              <ProtectedRoute>
                <LayoutWithFeedback>
                  <StreakConfigurations />
                </LayoutWithFeedback>
              </ProtectedRoute>

            }
          />
          <Route
            path="/plugin-configurations"
            element={

              <ProtectedRoute>
                <LayoutWithFeedback>
                  <PluginConfiguration />
                </LayoutWithFeedback>
              </ProtectedRoute>

            }
          />

          <Route
            path="/teams-comparison"
            element={

              <ProtectedRoute>
                <LayoutWithFeedback>
                  <TeamsComparison />
                </LayoutWithFeedback>
              </ProtectedRoute>

            }
          />
          <Route
            path="/forcedresetpassword"
            element={

              <ProtectedRoute>
                <LayoutWithFeedback>
                  <ForcedResetPassword />
                </LayoutWithFeedback>
              </ProtectedRoute>

            }
          />
          <Route
            path="/change-password"
            element={

              <ProtectedRoute>
                <LayoutWithFeedback>
                  <ChangePassword />
                </LayoutWithFeedback>
              </ProtectedRoute>

            }
          />
          <Route
            path="/reset-password"
            element={
              localStorage.getItem("password_expired") === "true" ? (
                <ResetPasswordWrapper />
              ) : (
                <Navigate to="/" replace />
              )
            }
          />
        </Routes>
        <ToastContainer
          position="top-center"
          autoClose={4000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      </>
    </ThemeProvider>
  );
};

export default App;
